// extracted by mini-css-extract-plugin
export default {"zoomModal":"G1-z"};